import { useEffect } from "react";

import { useSelectedLocation } from "components";
import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { usePermanentRealTimeUser } from "hooks";
import { useCustomersFilters } from "modules/CustomersDashboard/components/CustomerFilters/hooks/useCustomersFilters";
import { useCustomersDashboardListeners } from "modules/CustomersDashboard/listeners";
import { CustomersQueryKeys } from "modules/CustomersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useListCustomersQuery = (term?: string) => {
  const { user } = usePermanentRealTimeUser();
  const { filters } = useCustomersFilters();
  const listeners = useCustomersDashboardListeners();
  const { selectedLocation } = useSelectedLocation();

  const { data, isFetching, refetch } = useRealTimeTypedQuery({
    queryKey: CustomersQueryKeys.list,
    listeners,
    queryFn: async () => {
      const payload = {
        dealer_id: !user ? selectedLocation?.id : user.dealer_id,
        page: filters.page,
        is_lease_company: filters.is_lease_company,
        page_size: filters.page_size,
        term: term || filters.search_term
      };

      return (await ApiInstance.post(CustomersQueryKeys.list.endpoint, payload, CustomersQueryKeys.list.baseUrl)).data;
    }
  });

  useEffect(() => {
    refetch();
  }, [filters.page, filters.is_lease_company, filters.page_size, filters.search_term]);

  return { listCustomersData: data, isFetchingCustomersList: isFetching, refetchListCustomers: refetch };
};
